import { cn } from "@/lib/utils";

export default function IconCheck({ className }: { className?: string }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={cn("size-6", className)}>
			<path
				d="M21.0149 7.56384L10.4149 18.1638C10.321 18.2585 10.1932 18.3117 10.0599 18.3117C9.92657 18.3117 9.79877 18.2585 9.70489 18.1638L4.31489 12.7738C4.22023 12.68 4.16699 12.5522 4.16699 12.4188C4.16699 12.2855 4.22023 12.1577 4.31489 12.0638L5.01489 11.3638C5.10877 11.2692 5.23657 11.2159 5.36989 11.2159C5.50321 11.2159 5.63101 11.2692 5.72489 11.3638L10.0549 15.6938L19.6049 6.14384C19.8027 5.95205 20.1171 5.95205 20.3149 6.14384L21.0149 6.85384C21.1096 6.94772 21.1628 7.07552 21.1628 7.20884C21.1628 7.34216 21.1096 7.46995 21.0149 7.56384Z"
				fill="unherit"
			/>
		</svg>
	);
}
